module.exports = __webpack_public_path__ + "static/media/KC_logo.5731154a.png";